module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@2x-ed86c9389ef4ad3589c02e61ca988ddb.png";